import { config } from "./config";
import axios from "axios";
let loginApi = {};

loginApi.loginUsingEmailPass = (email, password) => {
  // let formData = new FormData();
  // formData.append("email", email);
  // formData.append("password", password);
  return axios.post(`${config.url}/auth/token`, {
    email,
    password
  });
};

loginApi.sendMagicPin = (email) => {
  return axios.post(`${config.url}/auth/magic-code/send`, { email });
};

loginApi.confirmMagicPin = (confirmCode, pin) => {
  return axios.post(`${config.url}/auth/magic-code/verify`, {
    code: confirmCode,
    pin,
  });
};

loginApi.slackRedirect = () => {
  return axios.get(`${config.url}/auth/slack/redirect`);
};

loginApi.slackAuthPoll = (code) => {
  return axios.post(`${config.url}/auth/slack/authcheck`, {
    code,
  });
};

loginApi.signInUsingSlack = (code) => {
  return axios.post(`${config.url}/auth/slack/signin`, {code});
};

loginApi.slackConnect = () => {
  return axios.get(`${config.url}/auth/slack/install`);
};

loginApi.slackConnectConfirmation = ({ code, state, error }) => {
  return axios.get(`${config.url}/auth/slack`, {
    params: {
      code,
      state,
      error
    },
  });
};

loginApi.forgetPassword = (email) => {
  return axios.post(`${config.url}/auth/forget-password/send`, {email});
};

loginApi.forgetPasswordConfirm = ({password,pin,code}) => {
  return axios.post(`${config.url}/auth/forget-password/verify`, {password,pin,code});
};

export default loginApi;
